import { IconFacebook } from './IconFacebook'

export default IconFacebook
